function removeListeners() {
  scrollEvents.removeListeners();
}

function initScripts() {
  window.transitioning = false;
  scrollEvents.addListeners();
  if(menu) menu.initialize();
  if(lazyImages) lazyImages.initialize();
  if(scrollingCards) scrollingCards.initialize();
  if(cart) cart.initialize();
  if(scrollingImages) scrollingImages.initialize();
  if(studioScroll) studioScroll.initialize();
  if(contactForm) contactForm.initialize();
  if(loadMore) loadMore.initialize();
  if(productTransition) productTransition.initialize();
  if(blogColumns) blogColumns.initialize();
  if(footer) footer.initialize();
  if(terms) terms.initialize();
  // SliderComponent.initialize();

  $(document).ready(() => {
    $('.collection-hero__menu-list li.active').on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
    })
  });
}

function logoFadeOut() {
  const logo = document.querySelector('.header__logo');
  gsap.to(logo, {
    opacity: 0,
    duration: 0.6,
    ease: 'expo.inOut'
  })
}

function logoFadeIn() {
  const logo = document.querySelector('.header__logo');
  gsap.to(logo, {
    opacity: 1,
    duration: 0.6,
    ease: 'expo.inOut'
  })
}

function resetScripts() {
  this.logo = document.querySelector('.header__logo');
  this.logo.classList.remove('hide')
  this.logo.classList.remove('reverse')
}

function isCollectionToProduct(prev, next) {
  const isCollection = prev.includes('collections')
  const isProduct = next.includes('products') && !next.includes('palette-studio')
  return isCollection && isProduct;
}

function isProductToCollection(prev, next) {
  const isCollection = prev.includes('collections/supply')
  const isProduct = next.includes('products') && !next.includes('palette-studio')
  return isCollection && isProduct;
}

function isContactSubmission(prev, next) {
  return prev.includes('contact') && next.includes('contact')
}

function isCollectionToCollection(prev, next) {
  return prev.includes('collections') && next.includes('collections')
}

function isBlogToBlog(prev, next) {
  return (
    (prev.includes('/tagged') && next.includes('/blogs/blog') && !next.includes('/blogs/blog/')) ||
    (prev.includes('/blogs/blog') && !prev.includes('/blogs/blog/') && next.includes('/tagged')) ||
    (prev.includes('/tagged') && next.includes('/tagged'))
  )
}

barba.init({
  transitions: [{
    name: 'opacity-transition',
    sync: true,
    leave(data) {
      window.transitioning = true;
      const container = data.current.container.querySelector('main');

      removeListeners();
      const homeImage = localStorage.getItem('homeImage');
      const heroImage = data.next.container.querySelector('.pal-hero img');
      if(homeImage && heroImage) {
        heroImage.setAttribute('srcset', homeImage);
        heroImage.setAttribute('src', homeImage);
      }

      const toProductFromCollection = isCollectionToProduct(barba.history.previous.url, barba.history.current.url)
      const collectionToCollection = isCollectionToCollection(barba.history.previous.url, barba.history.current.url)
      const blogToBlog = isBlogToBlog(barba.history.previous.url, barba.history.current.url)

      !collectionToCollection && !blogToBlog && logoFadeOut()
      container.style.overflow = 'hidden';

      if(collectionToCollection || blogToBlog) {
        data.current.container.style.scrollBehavior = 'auto';
        data.next.container.style.scrollBehavior = 'auto';
        return gsap.to(container, {
          scale: 1,
          z: 0,
          opacity: 0,
          duration: 0,
          delay: 0.3,
          ease: 'none'
        });
      }

      
      if(toProductFromCollection) {
        return gsap.to(container, {
          scale: 1,
          z: 0,
          opacity: 0,
          duration: 0,
          delay: 0.6,
          ease: 'none'
        });
      }

      gsap.to(container, {
        scale: 0.9,
        y: window.outerHeight * 0.1,
        z: 0,
        duration: 1.2,
        ease: 'expo.out'
      });
      
      gsap.to(container.querySelector('[data-main-overlay]'), {
        opacity: 0.1,
        duration: 0.5
      });
    },
    enter(data) {
      const container = data.next.container.querySelector('main');
      const footer = data.next.container.querySelector('#shopify-section-footer');
      const mediaContainer = data.next.container.querySelector('.product__media');
      
      const prevUrl = barba.history.previous.url;
      const nextUrl = barba.history.current.url;
      const toProductFromCollection = isCollectionToProduct(prevUrl, nextUrl);
      const collectionToCollection = isCollectionToCollection(prevUrl, nextUrl);
      const blogToBlog = isBlogToBlog(prevUrl, nextUrl)
      const contactSubmission = isContactSubmission(prevUrl, nextUrl);
      
      if(!collectionToCollection && !blogToBlog) window.scrollTo(0, 0);
      if(nextUrl.includes('about')) {
        document.querySelector('.sticky-menu').classList.add('about')
      } else {
        document.querySelector('.sticky-menu').classList.remove('about')
      }

      gsap.from(footer, {
        opacity: 0,
        duration: 1.1,
        delay: 1,
        z: 0,
        ease: 'expo.inOut',
      })
      
      if(collectionToCollection || blogToBlog) {        
        data.next.container.scrollTop = scrollEvents.getScroll();
        data.current.container.style.scrollBehavior = 'auto';
        data.next.container.style.scrollBehavior = 'auto';
        return gsap.from(container, {
          scale: 1,
          y: 0,
          z: 0,
          opacity: 0,
          duration: 0.3,
          ease: 'none'
        });
      }

      if(toProductFromCollection) {
        gsap.from(container, {
          scale: 1,
          y: 0,
          z: 0,
          opacity: 0,
          duration: 0.6,
          ease: 'none',
          onComplete: () => {
            resetScripts();
            logoFadeIn();
          }
        });

        return gsap.from(mediaContainer, {
          opacity: 0,
          duration: 0.2,
          ease: 'none',
          delay: 0.8,
          onComplete: () => {
            resetScripts();
            logoFadeIn();
          }
        })
      }

      return gsap.from(container, {
        scale: 1,
        opacity: 1,
        y: window.outerHeight,
        duration: 1.1,
        z: 0,
        ease: 'expo.inOut',
        delay: 0.2,
        onComplete: () => {
          resetScripts();
          logoFadeIn();
          if(window.location.hash) {
            window.location.href = `${data.next.url.path}#${data.next.url.hash}`
          }
        }
      });
    },
    after() {
      initScripts()
    }
  }]
});
